module.exports = __webpack_public_path__ + "media/images/icons/tags-5648a7f7f96db37dff4b7cde2788d330.svg";